
<template>
	<div :class="modal ? 'modal is-active' : 'modal'" v-if="modal">
  	<div class="modal-background"></div>
  	<div class="modal-card is-small">
      <header class="modal-card-head">
        <button @click="closeModal()" class="delete" aria-label="close"></button>
        <p class="modal-card-title">How do you want to be notified?</p>	
      </header>
      <section class="modal-card-body ph20 has-text-centered">
        <ValidationObserver ref="val_observer_outofstock">
          <form  ref="outofstock_form">
            <!-- only show if email is not available -->
            <div class="outof-stock-notification-type justify-content-start has-text-centered" >
              <div class="control mb10">
                <input
                  class="is-checkradio is-block"
                  id="out_of_stock_email"
                  type="radio"
                  name="outofstocksubscribe"
                  value="email"
                  v-model="form.contact_type"
                />
              <label for="out_of_stock_email" class="label-wrap">Email</label>
            </div>
            <!-- only show if phone is not available -->
            <div class="control">
              <input
                class="is-checkradio is-block"
                id="out_of_stock_phone"
                type="radio"
                name="outofstocksubscribe"
                value="phone"
                v-model="form.contact_type"
              />
              <label for="out_of_stock_phone" class="label-wrap">Phone</label>
            </div>
            
          </div>

          <div class="mt20 outofstock-no-contact-notice" v-if="!vg_user.phone && this.form.contact_type == 'phone'">
            <p>Just one more thing... We’re going to need your number to send you texts</p>
          </div>

         

          <div class="field signup-modal-fields">
              <div class="control mt20" v-show="!vg_user.email && (this.form.contact_type == 'email')">
                <validation-provider name="email" ref="contact_email" rules="required|email">
                    <template #default="{ errors }">
                      <input
                        class="input"
                        name="contact_type"
                        v-model="form.email"
                        :type="'email'"
                        :placeholder=" 'Email'"
                      />
                      <span class="validation-error">{{ errors[0] }}</span>
                    </template>
                  </validation-provider>
              </div>
              <div class="control mt20" v-show="!vg_user.phone && (this.form.contact_type == 'phone')">
                <validation-provider name="phone" ref="contact_phone" rules="required|phone_number|numeric">
                    <template #default="{ errors }">
                      <input
                        class="input"
                        name="contact_type"
                        v-model="form.phone"
                        type="number"
                        :maxlength="'10'"
                        :placeholder="'Phone Number'"
                      />
                      <span class="validation-error">{{ errors[0] }}</span>
                    </template>
                  </validation-provider>
              </div>
            </div>
   
            <div class="mt20" v-if="optinStatus == false">
              <div class="field mb30">
                <input class="is-checkradio" v-model="casl" id="optin_check_outofstock" type="checkbox" value="1">
                <label for="optin_check_outofstock" class="">I want to receive new offers & discounts!</label>
              </div>
            </div>

          </form>
        </ValidationObserver>
      </section>
      <footer class="modal-card-foot">
        <button @click="notifyWhenProductAvailable()" class="button is-large is-primary is-full-width">CONFIRM</button>
      </footer>
	  </div>
	</div>
</template>

<script>
import Helpers from '@/Components/Helpers/Helpers';
import { mapGetters, mapActions } from "vuex";
import 'moment-timezone';
import UserApis from '@/Components/Controllers/UserApis';

export default {
  data() {
    return {
      modal: false,
      variant: {},
      form: {
        phone: '',
        email: '',
        contact_type: 'email',
      },
      casl: false,
      optinStatus: false,
    };
  },

    computed: {
    ...mapGetters({
      vg_userId: "getLoggedInUserId",
      vg_user: "getLoggedInUser",
      vg_selectedStore: "location/selected", 
      vg_businessProfile: "businessprofile/detail", 
    })
  },

  mounted() {
    const self = this;
    bus.$on('variant-out-of-stock-notification', async (payload) => {
      this.modal = payload.modal;
      if(payload.modal) {
        this.optinStatus = this.vg_user.marketing_notification; // as default  
        let res = await UserApis.getUserBusinessCASl(this.vg_businessProfile.id);
        if( (res.status != 200) && (this.vg_user.marketing_notification == true) ) {
          this.optinStatus = true;
        } else {
          this.optinStatus = false;
        }
        this.variant = payload.variant;
        this.form.phone = this.vg_user.phone;
        this.form.email = this.vg_user.email;
      }
    })
  },



  watch: {
    'form.phone'(val){
      if(val){
        let newVal = val.toLowerCase();
        newVal = newVal.trim();
        newVal = newVal.replaceAll(/\s/g,'');
        if(val.length > 10){
          newVal = newVal.slice(0,10)
        } 
        this.form.phone = newVal;
      }
    },
    'form.email'(val){
      if(val){
        let newVal = val.toLowerCase();
        newVal = newVal.trim();
        newVal = newVal.replaceAll(/\s/g,'');
        this.form.email = newVal;
      }
    },
  },

  beforeDestroy() {
    bus.$off('variant-out-of-stock-notification');
  },

  methods: {
   
    closeModal() {
      this.$refs.val_observer_outofstock.reset();
      this.$refs.outofstock_form.reset();
      // reset
      this.form = {
        phone: '',
        email: '',
        contact_type: 'email',
      };
      this.modal = false;
      this.variant = {};
    },

    /**
     * Subscribe out of stock notification
     */
    async notifyWhenProductAvailable() {
       let checkType = [];
      if(this.form.contact_type == 'email') {
        checkType = ['contact_email'];
      } else {
        checkType = ['contact_phone'];
      }
      let validation = await Helpers.validateRefs(this, checkType);
      if( !validation ) {
        return;
      }

      this.va_spinner(true);
      // If optin status is false and casl true mean user checked the box, lets save
      if(this.optinStatus == false && this.casl) {
          let userUpdate = await UserApis.updateAccount({
            first_name: this.vg_user.first_name,
            last_name: this.vg_user.last_name,
            // email: this.form.email,
            phone: this.vg_user.phone,
            dob: this.vg_user.dob,
            marketing_notification: this.casl,
            email_notification: true,
            business_id: this.vg_businessProfile.id
        });
        if(userUpdate.status == 200){
          this.$store.dispatch('SET_USER_DETAILS', userUpdate.data.payload);
          UserApis.userBusinessCASlsubscribe(this.vg_businessProfile.id); 
        }
      }

      let res = await UserApis.createOutOfstockNotification({
        location_product_id: this.variant.location_product_id, 
        user_id: this.$store.getters.getLoggedInUserId,
        status: 'subscribed',
        location_product_varaint_id: this.variant.id, 
        contact_type: this.form.contact_type,
        contact: (this.form.contact_type == 'email') ? this.form.email : this.form.phone,
        product_variant_sku: this.variant.sku
      })
      this.va_spinner(false);

      if(res.status == 200){
        bus.$emit('refetch-outof-stock-notification', true);
        this.closeModal();
      }
      this.va_snackbar({
        type: res.status == 200 ? 'success' : 'warning',
        message: res.status == 200 ? res.data.msg : res.response.data.msg,
      });
   },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setOutOfStockPendingItem: "outofstocksubscriptions/setPendingItem",
    })
    
  },
};
</script>
